import requests from '@/utils/request.js'
import { callDynamicAPI } from '@/utils/dynamicApi.js'

// 使用动态API配置替代硬编码URL
export const getHomeInitDataAPI = () => callDynamicAPI('home', 'initData')
export const getnoread = () => callDynamicAPI('home', 'getUnread')
export const Cliernoread = () => callDynamicAPI('home', 'setRead')